
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { BlockedCompany } from "@/hooks/useBlockedCompanies";
import { Loader2 } from "lucide-react";
import { useState } from "react";

interface UnblockCompanyDialogProps {
  company: BlockedCompany | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export const UnblockCompanyDialog = ({
  company,
  open,
  onOpenChange,
  onConfirm,
}: UnblockCompanyDialogProps) => {
  const [isUnblocking, setIsUnblocking] = useState(false);

  const handleConfirm = async () => {
    setIsUnblocking(true);
    try {
      await onConfirm();
    } finally {
      setIsUnblocking(false);
      onOpenChange(false);
    }
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Confirm Unblock</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to unblock {company?.company_name}? Their traffic will start appearing in your dashboard again.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction 
            onClick={handleConfirm}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
            disabled={isUnblocking}
          >
            {isUnblocking && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Unblock Company
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
